import React, { useContext, cloneElement } from 'react';
import { D as DataListContext } from './DataListContext-CyU4jeBU.js';
import { T as Text } from './Text-BCmEgJBp.js';
import { B as Button } from './Button-DJQVVE0-.js';
import { E as EMPTY_FILTER_RESULTS_MESSAGE, b as EMPTY_RESULTS_MESSAGE, c as EMPTY_STATE_ACTION_BUTTON_ONLY_ERROR } from './DataList.const-CjTyAhOC.js';

var styles = {"emptyStateWrapper":"zg3w9nQga-M-"};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function DataListEmptyState(_) {
    return null;
}
function InternalDataListEmptyState() {
    const { emptyStateComponents: components, filtered } = useContext(DataListContext);
    const { message, action } = getMessages();
    return (React.createElement("div", { className: styles.emptyStateWrapper },
        React.createElement(Text, { align: "center" }, message),
        renderButton(action)));
    function getMessages() {
        const { defaultEmptyState, filteredEmptyState } = getEmptyStates(components);
        if (filtered) {
            return {
                message: (filteredEmptyState === null || filteredEmptyState === void 0 ? void 0 : filteredEmptyState.props.message) || EMPTY_FILTER_RESULTS_MESSAGE,
                action: filteredEmptyState === null || filteredEmptyState === void 0 ? void 0 : filteredEmptyState.props.action,
            };
        }
        return {
            message: (defaultEmptyState === null || defaultEmptyState === void 0 ? void 0 : defaultEmptyState.props.message) || EMPTY_RESULTS_MESSAGE,
            action: defaultEmptyState === null || defaultEmptyState === void 0 ? void 0 : defaultEmptyState.props.action,
        };
    }
}
function renderButton(action) {
    if (action) {
        if (action.type === Button) {
            return cloneElement(action, {
                variation: action.props.variation || "subtle",
            });
        }
        throw new Error(EMPTY_STATE_ACTION_BUTTON_ONLY_ERROR);
    }
    return;
}
function getEmptyStates(components) {
    const defaultEmptyState = components === null || components === void 0 ? void 0 : components.find(es => es.props.type === "empty" || es.props.type === undefined);
    const filteredEmptyState = components === null || components === void 0 ? void 0 : components.find(es => es.props.type === "filtered");
    return { defaultEmptyState, filteredEmptyState };
}

export { DataListEmptyState as D, InternalDataListEmptyState as I };
